const API_BASE_URL = import.meta.env.VITE_API_URL

// 1. Rutas por defecto (Gateway / Desplegado)
const DEFAULT_ROUTES = {
    HOMOLOGATIONS: `${API_BASE_URL}/api/homologations`,
    ASPIRANTS: `${API_BASE_URL}/api/aspirants`,
    AUTH: `${API_BASE_URL}/api/auth`,
    FILES: `${API_BASE_URL}/api/files`,
    INSCRIPTIONS: `${API_BASE_URL}/api/inscriptions`,
    INTERVIEWS: `${API_BASE_URL}/api/interviews`,
    INTEGRATIONS: `${API_BASE_URL}/api/integrations`,
    RESOURCES: `${API_BASE_URL}/api/resources`,
    STATS: `${API_BASE_URL}/api/stats`,
}

// 2. Rutas para desarrollo local (Microservicios independientes)
// Estos son los puertos típicos para correr cada servicio en tu máquina
const LOCAL_ROUTES = {
    HOMOLOGATIONS: 'http://localhost:8095/api/homologations',
    ASPIRANTS: 'http://localhost:8090/api/aspirants',
    AUTH: 'http://localhost:8081/api/auth',
    FILES: 'http://localhost:8091/api/files',
    INSCRIPTIONS: 'http://localhost:8082/api/inscriptions',
    INTERVIEWS: 'http://localhost:8082/api/interviews',
    INTEGRATIONS: 'http://localhost:8080/api/integrations',
    RESOURCES: 'http://localhost:8092/api/resources',
    STATS: 'http://localhost:8085/api/stats',
}

// 3. Exportar la configuración activa
export const ApiRoutes = {
    // A) Primero cargamos todas las rutas por defecto (Desplegado/Gateway)
    ...DEFAULT_ROUTES,

    // B) Aquí abajo puedes sobrescribir SOLO las que quieras correr en local.
    //    Simplemente descomenta la línea del servicio que estés probando en tu máquina.

    // HOMOLOGATIONS: LOCAL_ROUTES.HOMOLOGATIONS,
    // ASPIRANTS: LOCAL_ROUTES.ASPIRANTS,
    // AUTH: LOCAL_ROUTES.AUTH,
    // FILES: LOCAL_ROUTES.FILES,
    // INSCRIPTIONS: LOCAL_ROUTES.INSCRIPTIONS,
    // RESOURCES: LOCAL_ROUTES.RESOURCES,
    // STATS: LOCAL_ROUTES.STATS,
}
